import type { Props } from '../type';
import { SVGOutlinedIcon } from './SVGOutlinedIcon';

export const CloseOutlinedIcon = (props: Props) => (
  <SVGOutlinedIcon {...props}>
    <path
      d="M0.75 23.249L23.25 0.749023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.25 23.249L0.75 0.749023"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SVGOutlinedIcon>
);
